/**
 * Created by litao on 2018/11/22.
 */
export default {
  components: {
    editor: undefined,
  },

  data() {
    return {
      editorInstance: undefined,
    };
  },

  beforeDestroy() {
    this.editorInstance && this.editorInstance.destroy();
  },

  methods: {
    /**
     * 初始化编辑器
     * @param target
     * @param content
     */
    initEditor({ target, content }) {
      let hook = {
        cbValue: undefined,

        callback: (html) => {
          hook.cbValue &&
            typeof hook.cbValue === "function" &&
            hook.cbValue(html);
        },

        change(callback) {
          hook.cbValue = callback;
          // console.log(callback, "callbackcallback");
        },
        setVal(val) {
          console.log(val, "val");
        },
      };
      if (!target) {
        return hook;
      }
      if (!target) throw new Error("未获取到要实例化编辑器的容器id");

      target.setAttribute("id", "editor-" + Date.now());

      this.editorInstance = UE.getEditor(target.id, {
        serverUrl: "/__api/system/attachment/upload",
        initialFrameHeight: 400,
        zIndex: 3000,
      });

      this.editorInstance.addListener("ready", () => {
        content && this.editorInstance.setContent(content);
      });

      this.editorInstance.addListener("contentChange", () => {
        hook.callback(this.editorInstance.getContent());
      });

      hook.setVal = (val) => {
        // console.log(val, 'setVal');

        this.editorInstance.setContent(val);
      };

      return hook;
    },
  },
};



// WEBPACK FOOTER //
// ./src/configure/warp/support/editor.js